var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { injectIntl } from "@irati/utils/lang";
import ChartComponent from "./Chart";
import { getPercentChange, getDateFormatForRange, formatDate, createDateDescription } from "../helpers";
var formatDateAndChange = function (offset, dateFormatter) {
    return function (_a, idx) {
        var _b;
        var value = _a.value, date = _a.date, point = __rest(_a, ["value", "date"]);
        var prev = (_b = offset[idx - 1]) === null || _b === void 0 ? void 0 : _b.value;
        var change = (prev && value) ? getPercentChange(prev, value, 1) : "0";
        return __assign(__assign({}, point), { value: value,
            change: change, date: dateFormatter(date) });
    };
};
var formatSeries = function (data) {
    if (!data.length)
        return data;
    return data.map(function (_a) {
        var points = _a.points;
        if (!points.length)
            return { points: [] };
        var dateFormatter = formatDate(getDateFormatForRange(points[0].date, points.slice(-1)[0].date));
        return {
            points: points.map(formatDateAndChange(points, dateFormatter))
        };
    });
};
var PerkRedemptionsChart = function (_a) {
    var data = _a.data, formatMessage = _a.formatMessage, props = __rest(_a, ["data", "formatMessage"]);
    var chartProps = {
        keyX: "date",
        labelX: formatMessage({ id: "admin.reportingV3.chart.dateLabel" }),
        keyY: "value",
        labelY: formatMessage({ id: "admin.reportingV3.chart.totalLabel" }),
        customTooltip: [{
                label: formatMessage({ id: "admin.reportingV3.chart.changeLabel" }),
                key: "change"
            }],
        values: formatSeries(data)
    };
    var startDate = props.startDate, endDate = props.endDate, preset = props.preset, selectedSegment = props.selectedSegment;
    var dateDescription = createDateDescription({ startDate: startDate, endDate: endDate, preset: preset }, formatMessage);
    var segmentLabel = selectedSegment ? formatMessage({ id: "admin.reportingV3.chartTitle.bySegment" }, { segment: selectedSegment }) : "";
    return React.createElement(ChartComponent, __assign({ data: chartProps, title: formatMessage({ id: "admin.reportingV3.perkRedemptionsChart.title" }), subtitle: dateDescription, description: "" + segmentLabel }, props));
};
export default injectIntl(PerkRedemptionsChart);
